import css from 'styled-jsx/css';

const styles = css.global`.wppBtn{
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 28px;
  right: 24px;
  width: 66px;
  height: 66px;
  background-color: #00d566;
  z-index: 9999;
  border-radius: 50%;
  padding: 0;
  border: none;
  cursor: pointer;
}
#wppBtnDesktop{
  display: flex;
}
#wppBtnMobile{
  display: none;
}
@media (max-width:768px) {
  .wppBtn{
      bottom: 40px;
      right: 16px;
  }
  #wppBtnDesktop{
      display: none;
  }   
#wppBtnMobile{
      display: flex;
  }
}
body:has(#modalWpp[Open]){
  overflow-y: hidden;
}
#modalWpp{
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  pointer-events: none;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 23px 26px 37px 26px;
  width: 336px;
  height: 100%;
  transition: margin-right 0.5s linear;
  border: none;
  margin: auto;
  box-sizing: content-box;
  margin-right: -160%;
}
#modalWpp[open]{
  margin-right: 0;
  pointer-events: inherit;
}
#modalWpp::backdrop{
  backdrop-filter: brightness(0.5);
  transition: backdrop-filter .5s ease;
}
#closeBtnWpp{
  align-self: flex-end;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 23px;
  height: 23px;
  border: none;
  background-color: white;
  padding: 0;
  cursor: pointer;
}
#wppModalTitle, #wppModalTitle a{
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: 700;
  color: #cc0000;
  line-height: 24px;
}
#wppModalTitle a{
  cursor: pointer;
  text-decoration: underline;
}
#wppModalTitle img{
  width: 19px;
  height: 19px;
}
#wppQRCode{
  width: 191px;
  height: 191px;
  margin: 0 auto;
}
#chatOptions{
  list-style: disc;
  margin-left: 26px;
}
.textModal{
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 400;
  color: #767676;
  line-height: 20px;
}
#disclaimerModal{
  border-radius: 23px;
  background-color: #f3f5f8;
  margin: 15px auto 0 auto;
  padding: 15px 18px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
#disclaimerImageWpp{
  width: 26px;
  height: 26px;
  margin-right: 25px;
}
#textDisclaimerContainer{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}
.textDisclaimerWpp{
  font-family: "Open Sans";
  font-size: 13px;
  font-weight: 400;
  color: #767676;
  line-height: 18px;
}
.textDisclaimerWpp strong{
  font-family: "Open Sans";
  font-size: 13px;
  font-weight: 700;
  color: #767676;
  line-height: 18px;
}
`;

export default styles;